import {useRef} from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

import {UI_PERMISSION_TYPE} from "../../../Components/adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import {ICON_NAMES} from "../../generalConstants.js/generalConstants";
import {useHotkey} from "../../hooks/useHotkey";
import IconButton from "../IconButton";

const FilterButton = ({
  onFilter,
  delFilter,
  questionTitle = "",
  areFiltersDefined = false,
  disabled = false,
  children,
}) => {
  const containerRef = useRef();

  useHotkey(onFilter, "Space", "KeyF");
  // useHotkey(delFilter, "Escape");

  return (
    <div className="filters_containe h100 fcCol aistr jcsb" style={{width: "8rem"}} ref={containerRef}>
      <div className="flex_container nowrap gap pl0_5 pr aibl" style={{height: "2.9em"}}>
        <IconButton
          ariaLabel="Apply filters"
          nameIcon={ICON_NAMES.FILTER_ON}
          tooltipMessage={questionTitle}
          onClick={() => onFilter()}
          disabled={disabled}
          classNameBtn={clsx("filter-icon-btn", areFiltersDefined ? "definedFilters" : "")}
          classNameIcon={areFiltersDefined ? "no-scale" : ""}
          uiPermissionType={UI_PERMISSION_TYPE.READABLE}
        />
        <IconButton
          ariaLabel="Clear filters"
          nameIcon={ICON_NAMES.FILTER_OFF}
          tooltipMessage="Clear filters"
          onClick={delFilter}
          disabled={disabled}
          widthIcon={26}
          heightIcon={26}
          uiPermissionType={UI_PERMISSION_TYPE.READABLE}
        />
      </div>
      <div className="" style={{width: "6em"}}>
        {children}
      </div>
    </div>
  );
};

FilterButton.propTypes = {
  onFilter: PropTypes.func,
  delFilter: PropTypes.func,
  areFiltersDefined: PropTypes.bool,
};

export default FilterButton;
